import { cn } from '@/lib/utils';
import type { Dictionary } from '@/lib/i18n/dictionaries';

type LogoSize = 'md' | 'lg';

const sizeClasses: Record<LogoSize, string> = {
  // Header — fits inside the sticky bar (constrained height)
  md: 'h-[3.9rem] w-auto sm:h-16',
  // Footer — can breathe more, no height container
  lg: 'h-[4.9rem] w-auto md:h-20 lg:h-24',
};

export function Logo({
  className,
  inverse = false,
  size = 'md',
  dict,
}: {
  className?: string;
  inverse?: boolean;
  size?: LogoSize;
  dict?: Dictionary;
}) {
  return (
    <span className={cn('inline-flex items-center', className)}>
      <img
        src={inverse ? '/logo-vps-white.png' : '/logo-vps.png'}
        alt={dict?.brand.fullName ?? 'VPS Laboratorio'}
        className={sizeClasses[size]}
      />
    </span>
  );
}
